import React from 'react';
import type {IconProps} from 'components/icons/types';
import {
  AIIcon,
  CheckCircleIcon,
  GhostIcon,
  SearchIcon,
  VerifiedIcon,
  VerifiedUncheckedIcon,
} from 'components/icons';
import type {LinkStatusIconStatus} from './types';

type Props = {
  status?: LinkStatusIconStatus;
  color: IconProps['color'];
};

export const LinkStatusIcon: React.FC<Props> = ({status, color}) => {
  return status === 'unnamed' ? (
    <AIIcon color={color} />
  ) : status === 'empty' ? (
    <SearchIcon color={color} />
  ) : status === 'unverified' ? (
    <GhostIcon color={color} />
  ) : status === 'verified' ? (
    <CheckCircleIcon color={color} />
  ) : status === 'externalVerified' ? (
    <VerifiedIcon color={color} />
  ) : status === 'verifiedUnchecked' ? (
    <VerifiedUncheckedIcon color={color} />
  ) : null;
};
